import React, { useEffect, useState } from "react";
import axios from "axios";
// import Papa from "papaparse";

import CoronaChart from "components/CoronaChartsNew";
import Layout from "components/Layout";
import Loading from "components/Loading";
import DataTable from "components/DataTableWorld";

import { formatName, numberWithCommas } from "helpers/miscHelpers";
import { createTotalsObject, processDataNew } from "helpers/CoronaHelpersNew";

import {
  StyledContainer,
  StyledAlertBox,
  StyledUIGrid,
} from "styles/pageStyles";
import { StyledSummaryBox } from "components/CoronaChartsNew/styles";

const initialCountries = ["usa", "", "", ""];

const timelineDataURL = "https://corona.lmao.ninja/v2/historical?lastdays=all";
// const timelineDataURL = "http://localhost:8000/tempNewData.json";

const IndexPage = () => {
  const [tableData, setTableData] = useState([]);
  const [loadedData, setLoadedData] = useState(null);
  const [theTotals, setTheTotals] = useState({});
  const [chartType, setChartType] = useState("newCases");
  const [noteVisible, setNoteVisible] = useState(true);

  function processJsonData(data) {
    const newData = processDataNew(data);
    const totals = createTotalsObject(newData.data);

    const totalsDisplayObj = {
      cases: Object.entries(totals.timeline.cases).slice(-1)[0][1],
      deaths: Object.entries(totals.timeline.deaths).slice(-1)[0][1],
      newCases: Object.entries(totals.timeline.newCases).slice(-1)[0][1],
      newDeaths: Object.entries(totals.timeline.newDeaths).slice(-1)[0][1],
    };
    setTheTotals(totalsDisplayObj);

    newData.data.push(totals);
    setLoadedData(newData.data);
    setTableData(newData.data);
  }

  // effects that run on initial load
  useEffect(() => {
    async function dataFetch() {
      const dataStream = await axios.get(timelineDataURL);
      const dataAll = dataStream.data;
      processJsonData(dataAll);
    }

    dataFetch();
  }, []);

  return (
    <Layout>
      <StyledContainer>
        <section>
          {/* {noteVisible && (
            <StyledAlertBox>
              <p>
                Note: The recoveries data from Johns Hopkins has been
                unreliable, so it has been removed for now.
              </p>

              <p>
                <b>
                  I'm only including data from the 50 states + D.C. here, hence
                  the slightly lower totals you may see elsewhere. (No cruise
                  ship data, and no island territories data.)
                </b>
              </p>

              <p>
                <button
                  className="closebtn"
                  type="button"
                  onClick={() => setNoteVisible(false)}
                >
                  X
                </button>
              </p>
            </StyledAlertBox>
          )} */}
          <StyledSummaryBox>
            <h3>World Totals:</h3>
            {theTotals.cases && (
              <div className="items">
                <div>
                  Total Cases: <span>{numberWithCommas(theTotals.cases)}</span>
                </div>
                <div>
                  Total Deaths:{" "}
                  <span>{numberWithCommas(theTotals.deaths)}</span>
                </div>
                <div>
                  New Cases: <span>{numberWithCommas(theTotals.newCases)}</span>
                </div>
                <div>
                  New Deaths:{" "}
                  <span>{numberWithCommas(theTotals.newDeaths)}</span>
                </div>
              </div>
            )}
          </StyledSummaryBox>

          <StyledUIGrid className="ui-grid">
            <div className="left-side">
              <h1>
                Compare By Country:{" "}
                {chartType === "casesPer100k"
                  ? "Total Cases Per 100K Pop."
                  : chartType === "activeCases"
                  ? "Active Cases"
                  : chartType === "newCases"
                  ? "New Daily Cases"
                  : chartType === "newDeaths"
                  ? "New Daily Deaths"
                  : chartType === "deathsPer100k"
                  ? "Deaths Per 100K Pop."
                  : formatName(chartType)}
              </h1>
              <hr />
              {loadedData && (
                <CoronaChart
                  chartType={chartType}
                  dateCount={30}
                  initialCountries={initialCountries}
                  loadedData={loadedData}
                  setChartType={setChartType}
                />
              )}
            </div>

            <div className="right-side">
              {tableData.length > 0 && <DataTable data={tableData} />}
            </div>
          </StyledUIGrid>

          {!loadedData && <Loading />}
        </section>
      </StyledContainer>
    </Layout>
  );
};
export default IndexPage;
